import React, { useState } from 'react';
import { NavigationProps } from '../types/navigation';
import { Button } from '../components/ui/Button';
import { useStore } from '../lib/store';
import { Smartphone, Lock, Truck } from 'lucide-react';
export function GoFishPage({
  onNavigate
}: NavigationProps) {
  const {
    user
  } = useStore();
  const [castPower, setCastPower] = useState(0);
  const [isCasting, setIsCasting] = useState(false);
  const isLocked = (user?.points || 0) < 500;
  // Mock motion detection
  const handleSimulatedCast = () => {
    if (isLocked) return;
    setIsCasting(true);
    let power = 0;
    const interval = setInterval(() => {
      power += 10;
      setCastPower(power);
      if (power >= 100) {
        clearInterval(interval);
        finishCast();
      }
    }, 50);
  };
  const finishCast = () => {
    setIsCasting(false);
    setCastPower(0);
    alert('Nice cast! You caught a discount code for home delivery!');
    // Logic to add reward would go here
  };
  if (isLocked) {
    return <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-6 text-center relative overflow-hidden" data-id="element-498">
        <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-499"></div>

        <div className="relative z-10 bg-gray-800 p-8 rounded-3xl border border-gray-700 max-w-sm w-full shadow-2xl" data-id="element-500">
          <div className="w-20 h-20 bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-501">
            <Lock className="w-10 h-10 text-gray-400" data-id="element-502" />
          </div>

          <h1 className="text-2xl font-bold text-white mb-2" data-id="element-503">
            Level 500 Required
          </h1>
          <p className="text-gray-400 mb-6" data-id="element-504">
            Earn 500 points to unlock Virtual Fishing.
          </p>

          <div className="bg-blue-900/30 p-4 rounded-xl border border-blue-500/30 mb-6 text-left" data-id="element-505">
            <h3 className="text-blue-300 font-bold mb-1 flex items-center" data-id="element-506">
              <Truck className="w-4 h-4 mr-2" data-id="element-507" />
              What is this?
            </h3>
            <p className="text-sm text-blue-100/80" data-id="element-508">
              Virtual fishing lets you catch products anywhere and get them{' '}
              <strong data-id="element-509">delivered to your home</strong> or pick up flexibly.
            </p>
          </div>

          <div className="w-full bg-gray-700 h-2 rounded-full overflow-hidden mb-2" data-id="element-510">
            <div className="bg-blue-500 h-full transition-all duration-1000" style={{
            width: `${Math.min((user?.points || 0) / 500 * 100, 100)}%`
          }} data-id="element-511"></div>
          </div>
          <p className="text-xs text-gray-500 font-mono mb-6" data-id="element-512">
            {user?.points || 0} / 500 Points
          </p>

          <Button onClick={() => onNavigate('feed')} variant="secondary" className="w-full" data-id="element-513">
            Back to Feed
          </Button>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gradient-to-b from-blue-400 to-blue-800 flex flex-col items-center justify-center p-6 text-center relative overflow-hidden" data-id="element-514">
      {/* Unlocked View */}
      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-515"></div>

      <div className="relative z-10 space-y-8" data-id="element-516">
        <div className={`w-48 h-48 bg-white/20 rounded-full flex items-center justify-center mx-auto backdrop-blur-md border-4 border-white/30 shadow-2xl transition-transform duration-200 ${isCasting ? 'scale-110' : ''}`} data-id="element-517">
          <span className="text-8xl" data-id="element-518">🎣</span>
        </div>

        <div className="space-y-2 text-white" data-id="element-519">
          <h1 className="text-4xl font-black drop-shadow-md" data-id="element-520">Cast Your Line</h1>
          <p className="text-blue-100 text-lg max-w-xs mx-auto" data-id="element-521">
            Swing your phone to catch home delivery rewards!
          </p>
        </div>

        <div className="flex justify-center items-center space-x-4" data-id="element-522">
          <Smartphone className={`w-12 h-12 text-white ${isCasting ? 'animate-spin' : 'animate-bounce'}`} data-id="element-523" />
        </div>

        <Button onMouseDown={handleSimulatedCast} onTouchStart={handleSimulatedCast} className="w-full max-w-xs text-xl py-6 shadow-xl shadow-blue-900/50 border-4 border-yellow-200" data-id="element-524">
          {isCasting ? 'CASTING...' : 'TAP & HOLD TO CAST'}
        </Button>
      </div>
    </div>;
}